import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const RecentDrillHistory = ({ drills }) => {
  const navigate = useNavigate();

  const getScoreColor = (score) => {
    if (score >= 80) return 'text-success';
    if (score >= 60) return 'text-primary';
    if (score >= 40) return 'text-warning';
    return 'text-error';
  };

  const getScoreBgColor = (score) => {
    if (score >= 80) return 'bg-success/10';
    if (score >= 60) return 'bg-primary/10';
    if (score >= 40) return 'bg-warning/10';
    return 'bg-error/10';
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const today = new Date();
    const yesterday = new Date(today);
    yesterday?.setDate(yesterday?.getDate() - 1);

    if (date?.toDateString() === today?.toDateString()) {
      return 'Today';
    } else if (date?.toDateString() === yesterday?.toDateString()) {
      return 'Yesterday';
    } else {
      return date?.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    }
  };

  // Get actual drill history or use empty array
  const drillsToShow = drills && drills.length > 0 ? drills : [];

  return (
    <div className="bg-card rounded-2xl p-6 shadow-card border border-border">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center">
            <Icon name="History" size={24} color="var(--color-primary)" />
          </div>
          <div>
            <h2 className="text-xl font-semibold text-foreground">Recent Drills</h2>
            <p className="text-sm text-muted-foreground">Your practice history</p>
          </div>
        </div>
        <button
          onClick={() => navigate('/app/daily-drill')}
          className="text-sm font-medium text-primary hover:text-primary/80 transition-colors"
        >
          View All
        </button>
      </div>
      <div className="space-y-3">
        {drillsToShow.length > 0 ? (
          drillsToShow.map((drill, index) => (
            <div
              key={`${drill?.id || drill?.drillId}-${index}-${drill?.completedAt || drill?.completedDate}`}
              className="p-4 rounded-lg border border-border hover:border-primary/50 hover:bg-primary/5 transition-all duration-200 cursor-pointer"
              onClick={() => navigate(`/daily-drill?drillId=${drill?.id || drill?.drillId}`)}
            >
              <div className="flex items-start justify-between mb-2">
                <div className="flex-1">
                  <h3 className="text-sm font-medium text-foreground mb-1">{drill?.title || drill?.scenario}</h3>
                  <div className="flex items-center gap-2 text-xs text-muted-foreground">
                    <Icon name="Calendar" size={12} />
                    <span>{formatDate(drill?.completedAt || drill?.completedDate)}</span>
                    {drill?.timeTakenSeconds && (
                      <>
                        <div className="w-1 h-1 rounded-full bg-border"></div>
                        <Icon name="Clock" size={12} />
                        <span>{Math.round(drill?.timeTakenSeconds / 60)} min</span>
                      </>
                    )}
                  </div>
                </div>
                {drill?.score && (
                  <div className={`px-3 py-1.5 rounded-lg ${getScoreBgColor(drill?.score)}`}>
                    <span className={`text-sm font-semibold ${getScoreColor(drill?.score)}`}>
                      {drill?.score}
                    </span>
                  </div>
                )}
              </div>
            </div>
          ))
        ) : (
          <div className="p-4 text-center text-muted-foreground text-sm">
            <p>No drills completed yet</p>
            <p className="text-xs mt-1">Complete a drill to see your history here</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default RecentDrillHistory;